export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'km', name: 'ខ្មែរ', flag: '🇰🇭' }
];
